import { withInstall } from '@sgui-plus/utils/with-install'
import Row from './src/row'

export const SgRow = withInstall(Row)
export default SgRow

export * from './src/row'
